$(document).ready(function() {
    $("#accept_cart").on("click", function(e) {
        e.preventDefault();
        var data = JSON.parse($.cookie("cookieStore"));
        var exist = false;
        for (var i = 1; i <= data.length; i++) {
            if (data[i]) {
                exist = true;
                break;
            }
        }
        if (exist) {
            window.location = "/credentials/show";
        }
    });

    if ($.cookie("cookieStore")) {
        var data = JSON.parse($.cookie("cookieStore"));
        var total = 0;
        for (var i = 1; i <= data.length; i++) {
            if (data[i]) {
                var id = "cart_" + i,
                    idClick = "element_" + i,
                    _id = "#" + id,
                    price = "price_" + i,
                    suma = "total_" + i;
                var sum =
                    parseInt(data[i]["cena"]) * parseInt(data[i]["kolicina"]);
                total += sum;
                $(".table").append("<div id='" + id + "' class='row'></div>");
                $(_id).append(
                    "<div class='td'><img src='" + data[i]["slika"] + "'></div>"
                );
                $(_id).append(
                    "<div class='td'><a href='single/" +
                        data[i]["uuid"] +
                        "'>" +
                        data[i]["name"] +
                        "</a></div>"
                );
                $(_id).append(
                    "<div class='td' id='" +
                        price +
                        "'>" +
                        data[i]["cena"] +
                        "</div>"
                );
                $(_id).append(
                    "<div class='td'><div class='qty'><input disabled id='" +
                        idClick +
                        "' value=" +
                        data[i]["kolicina"] +
                        "> <button onclick='modify_qty(-1, " +
                        idClick +
                        ", " +
                        i +
                        ");'><i class='fa fa-angle-down' aria-hidden='true'></i></button><button onclick='modify_qty(1, " +
                        idClick +
                        ", " +
                        i +
                        ");'><i class='fa fa-angle-up' aria-hidden='true'></i></button></div></div>"
                );
                $(_id).append(
                    "<div class='td' id='" + suma + "'>" + sum + ",00 din</div>"
                );
                $(_id).append(
                    "<div class='td'><button onclick='remove(" +
                        i +
                        ");' class='delete'><i class='fa fa-times' aria-hidden='true'></i></button></div>"
                );
                $("#subtotal").text(total + ",00 din");
            }
        }
    }
});
